<div class="row col-12 col-sm-12 my-account-container" [ngClass]="isMobile? 'px-0':''">
  @if (!isMobile) {
    <div class="col-3 col-sm-3 my-account-left-nav">
      <app-my-account-left-sidenav [navState]="'SupportTicketNavNode'"></app-my-account-left-sidenav>
    </div>
  }
  <div
    [ngClass]="isMobile? 'col-12 create-new-ticket-section' :'col-12 col-sm-12 col-md-12 col-lg-9 my-account-right-nav'">
    @if (messages.length>0) {
      @for (errorMsg of messages; track errorMsg; let i = $index) {
        <div class="alert alert-danger">
          <span class="pl-3">{{ errorMsg | cxTranslate }}</span>
          <button class="close" type="button" (click)="clear(i)">
            <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
          </button>
        </div>
      }
    }
    @if (getData?.b2bUnitsWSList && getData?.b2bUnitsWSList?.length >0 ) {
      <h1 class="myProfileTopHeader m-0">{{'common.text_account_supporttickets_requestSupport'|cxTranslate}}
      </h1>
      <div class="myProfileBody">
        <form [formGroup]="createnewTicket" novalidate autocomplete="off">
          <div class="customerIdContainer">
            <div class="container-cus-block">
              <div class="acc-sec-content">
                <div class="customer-block-title">
                {{'common.text_warranty_submit_customer_id'|cxTranslate}}</div>
                <div class="select">
                  <select name="customer" class="selectbox-customer" formControlName="customerId">
                    @for (opt of getData?.b2bUnitsWSList; track opt) {
                      <option [value]="opt?.uid"
                        [disabled]="opt?.orderBlocked" [ngClass]="opt?.orderBlocked ? 'bgGrey':''">
                        @if (opt?.salesArea1) {
                          <span> {{ opt?.salesArea1}}&nbsp;|&nbsp;</span>
                        }
                        @if (opt?.salesArea2) {
                          <span>{{opt?.salesArea2
                          |cxTranslate}}&nbsp;|&nbsp;</span>
                        }
                        @if (opt?.salesArea3) {
                          <span> {{opt?.salesArea3 }}</span>
                        }
                      </option>
                    }
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="subjectDiv d-flex px-2 flex-column col-12">
            <label for="subject"
            class="subject-label">{{'common.text_account_supporttickets_createTicket_subject_mandatory'|cxTranslate}}</label>
            <input type="text" formControlName="subject">
          </div>
          <div class="form-group category-div p-0 mt-4 row mx-0 col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="col-xs-12 p-0 col-sm-6 col-md-6 col-lg-6 px-2 create-new-ticket-category">
              <label for="categoryId"
              class="control-label">{{'common.text_subcategories_label'|cxTranslate}}*</label>
              <div class="select-box">
                <select name="titleCode" class="form-control" formControlName="categoryId"
                  (change)="onCategoryChange()">
                  <option value="null" disabled>
                    {{'common.text_account_supporttickets_createTicket_category_option1'|cxTranslate}}
                  </option>
                  @for (item of getData?.categories; track item; let i = $index) {
                    <option [value]="item.code">
                      {{
                      'common.text_account_supporttickets_createTicket_ticketCategory_'+item?.code.toUpperCase()|cxTranslate}}
                    </option>
                  }
                </select>
              </div>
            </div>
            <div class="col-xs-12 p-0 col-sm-6 col-md-6 col-lg-6 px-2">
              <label for="associatedTo"
              class="control-label">{{'common.text_account_supporttickets_createTicket_associatedTo'|cxTranslate}}*</label>
              <div class="select-box">
                <select name="titleCode" class="form-control" formControlName="associatedTo">
                  <option value="null" disabled [selected]="form.associatedTo.value == null">
                    {{'common.text_account_supporttickets_createTicket_associatedTo_option2'|cxTranslate}}
                  </option>
                  @for (item of associatedTo; track item; let i = $index) {
                    <option [value]="item">
                    {{item}}</option>
                  }
                </select>
              </div>
            </div>
          </div>
          <div class="textAreaBox mt-4 d-flex flex-column create-ticket-textarea">
            <label for="message"
            class="message-label">{{'common.text_account_supporttickets_createTicket_message_mandatory'|cxTranslate}}</label>
            <textarea name="message" formControlName="message" cols="30" rows="10"></textarea>
          </div>
          <div
            class="buttonContainerDiv row mx-0 mt-5 col-xs-12 col-sm-12 col-lg-12 px-0 align-items-start create-ticket-content">
            <div
              class="form-group file-upload js-file-upload row mx-0 col-xs-12 col-sm-6 col-md-6 create-ticket-file-upload">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 d-flex flex-column p-0">
                <div class="file-upload__wrapper btn btn-primary centering btn-block btn-blue"
                  id="chooseFileButton">
                  <span
                  class="f-20-btn">{{'common.text_warranty_view_add_information'|cxTranslate}}</span>
                  <input type="file" accept=".doc, .docx , .txt, .tif, .gif , .jpg, .pdf, image/* "
                    #fileInput class="file-upload__input js-file-upload__input "
                    (change)="onFileSelected(fileInput)">
                  </div>
                  @if (filenameisThere) {
                    <strong
                      class="fs-16"><span>{{'common.text_account_supporttickets_content1'|cxTranslate}}</span></strong>
                    } @else {
                      <strong class="fs-16"><span>({{fileName}})</span></strong>
                    }
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-6 fs-16 p-0">
                  {{'common.text_account_supporttickets_content2'|cxTranslate}}</div>
                </div>
                <div
                  class="row mx-0 col-xs-12 col-sm-6 col-md-6 align-items-center justify-content-end create-ticket-file-upload">
                  <button type="button" (click)="resetButton()"
                  class="btn btn-primary btn-blue f-20-btn col-xs-12 col-sm-12 col-lg-5">{{'common.text_account_reset'|cxTranslate}}</button>
                  <button (click)="onSubmit()" type="submit"
                    class="btn btn-primary f-20-btn col-xs-12 col-sm-12 col-lg-5 ml-2 create-ticket-submit-btn">{{'common.mobile_checkout_multi_button_submit'|cxTranslate}}<img
                  class="arrow-img" src="/icons/link-white.svg" style="width: 20px;"></button>
                </div>
              </div>
            </form>
          </div>
        }
      </div>
    </div>